module.exports = __webpack_public_path__ + "img/sEternalFi_350x350.3c2be2b4.jpg";